import React from 'react';

const CloseButton = () => {
  return (
    <svg width="57.087" height="57.087" xmlns="http://www.w3.org/2000/svg">
      <g data-name="Group 2404" transform="translate(9 9)">
          <circle data-name="Ellipse 15" cx="19.544" cy="19.544" r="19.544" fill="#f56060"/>
          <circle data-name="Ellipse 27" cx="19.544" cy="19.544" r="19.544" fill="#f56060"/>
          <g data-name="Group 2701">
              <path data-name="Line 81" transform="rotate(-45 21.855 -9.054)" fill="none" stroke="#FFFFFF" d="M0 0v19.067"/>
              <path data-name="Line 82" transform="rotate(45 -2.311 38.129)" fill="none" stroke="#FFFFFF" d="M0 0v19.067"/>
          </g>
      </g>
    </svg>
  )
}

export default CloseButton;